import React, { FC, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

interface SearchConditionDetails {
  id: number
  name: string
  start_date: string
  end_date: string
  team_ids: number[]
  member_ids: number[]
  keywords: string[]
  service_names: string[]
  category_ids: number[]
}

interface Props {
  miniMenuDisplay: boolean,
  searchConditionList: SearchConditionDetails[],
  closeCallback: VoidFunction,
  selectCallback: (id: number) => void,
  updateCallback: (id: number, title: string) => void,
  deleteCallback: (id: number, title: string) => void,
}

const MiniMenu: FC<Props> = (props) => {
  const { t } = useTranslation()

  const {
    miniMenuDisplay,
    searchConditionList,
    closeCallback,
    selectCallback,
    updateCallback,
    deleteCallback,
  } = props

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (miniMenuDisplay) {
      html.classList.add('modal_open')
    } else {
      html.classList.remove('modal_open')
    }
  }, [miniMenuDisplay])

  return (
    <>
      <div className={`search_condition_menu ${miniMenuDisplay || 'none'}`}>
        <div className="title">
          {t('search.conditions.menu.title')}
        </div>
        {
          searchConditionList.length ? (
            <ul>
              {
                searchConditionList.map((value) => (
                  <li key={value.name}>
                    <div
                      onClick={() => selectCallback(value.id)}
                      role="none"
                      className="name"
                    >
                      {value.name}
                      <div className="comment">
                        {t('search.conditions.menu.comment.apply')}
                      </div>
                    </div>
                    <div className="action_area">
                      <button
                        type="button"
                        onClick={() => updateCallback(value.id, value.name)}
                      >
                        <ReactSVG
                          src="/static/images/icon/icon-modify.svg"
                          className="icon"
                        />
                        <div className="comment">
                          {t('search.conditions.menu.comment.update')}
                        </div>
                      </button>
                      <button
                        type="button"
                        onClick={() => deleteCallback(value.id, value.name)}
                      >
                        <ReactSVG
                          src="/static/images/icon/icon-trash.svg"
                          className="icon"
                        />
                        <div className="comment">
                          {t('search.conditions.menu.comment.delete')}
                        </div>
                      </button>
                    </div>
                  </li>
                ))
              }
            </ul>
          ) : (
            <div className="no_data">
              {t('search.conditions.menu.no_data')}
            </div>
          )
        }
      </div>
      <div className={`close_screen ${miniMenuDisplay || 'none'}`} role="presentation" onClick={closeCallback} />
    </>
  )
}

export default MiniMenu
